// extracted by mini-css-extract-plugin
module.exports = {"table-popover":"_2-9sM-","tablePopover":"_2-9sM-","body":"_3moCl-"};